import type { BadgeProps } from '@/shared/components/ui/badge';

/**
 * 거래 상태 statusView ↔ 화면 규칙 (docs/api/accounts.md 「거래 상태 statusView ↔ 화면」)
 * 좌측 목록 그룹 · 배지 색 · 처방 등록 가능 여부를 한곳에서 정한다.
 */
export type RelationshipGroup = 'applying' | 'ongoing' | 'closed';

/** 처방 등록 가능 — 거래처 승인(승인 7일 이내)도 거래중으로 본다 */
const ONGOING = ['거래 중', '거래처 승인'];
const CLOSED = ['거래 종료', '신청 거절'];

/** 거래 신청 · 이관 확인 중 · 확인 중은 신청 그룹. 모르는 값도 등록을 막는 쪽(신청)으로 둔다 */
export const getRelationshipGroup = (statusView: string): RelationshipGroup => {
  if (ONGOING.includes(statusView)) return 'ongoing';
  if (CLOSED.includes(statusView)) return 'closed';
  return 'applying';
};

export const RELATIONSHIP_GROUP_LABEL: Record<RelationshipGroup, string> = {
  applying: '거래 신청',
  ongoing: '거래중',
  closed: '종료 · 거절',
};

export const getStatusBadgeTone = (statusView: string): BadgeProps['tone'] => {
  switch (statusView) {
    case '이관 확인 중':
    case '확인 중':
      return 'warning';
    case '거래 중':
    case '거래처 승인':
      return 'success';
    case '신청 거절':
      return 'danger';
    case '거래 종료':
      return 'muted';
    default:
      return 'neutral';
  }
};

/** 병원급은 의약품, 의원급은 제약사 단위로 거래를 본다 (M-05) */
export const isHospitalType = (clinicTypeLabel?: string | null) =>
  clinicTypeLabel === '병원급';
